import tabNavigation from '../../../../../../src24/js/modules/tabNavigation';
import elementStateToggle from '../../../../../../src24/js/modules/elementStateToggle';
import sliderTabNavigation from '../../../../../../src24/js/modules/sliderTabNavigation';

window.addEventListener('load', () => {
    tabNavigation.init();
    sliderTabNavigation.init();
    elementStateToggle.init({
        preventDefault: true,
        hasContextElement: {
            elements: '.js-state-context',
            attr: 'href',
        },
        toggleActiveElement: true,
    });
});
